import React from "react";
import { Phone, Mail, MapPin, Wrench, Instagram } from "lucide-react";
import { COMPANY, SERVICES, NAV_LINKS } from "../mock";

export default function Footer() {
  return (
    <footer id="contact" className="bg-[#07304f] text-white">
      <div className="copper-band h-1.5 w-full" />
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="inline-block mb-4">
            <img
              src="/assets/logo_transparent.png"
              alt="Cheerings Plumbing Group"
              className="h-16 w-auto object-contain brightness-0 invert"
            />
          </div>
          <p className="text-white/75 text-sm mb-5">
            Sydney's trusted family-owned plumbing team. Available 24/7 across NSW for
            residential and commercial customers.
          </p>
          <div className="flex gap-3">
            <a
              href={COMPANY.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-sky-500 flex items-center justify-center transition-colors"
              aria-label={`Follow us on Instagram ${COMPANY.instagramHandle}`}
              data-testid="footer-instagram-link"
            >
              <Instagram size={16} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-bold text-white mb-4 uppercase text-sm tracking-wider">Quick Links</h4>
          <ul className="space-y-2">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-white/75 hover:text-sky-300 text-sm transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-white mb-4 uppercase text-sm tracking-wider">Services</h4>
          <ul className="space-y-2">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.id}>
                <a href="#services" className="text-white/75 hover:text-sky-300 text-sm transition-colors">
                  {s.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-white mb-4 uppercase text-sm tracking-wider">Contact</h4>
          <ul className="space-y-3 text-xs">
            <li className="flex items-start gap-3">
              <Phone size={16} className="text-sky-300 mt-0.5 shrink-0" />
              <a href={`tel:${COMPANY.phoneLink}`} className="text-white/90 hover:text-sky-300 whitespace-nowrap">
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="text-sky-300 mt-0.5 shrink-0" />
              <a
                href={`mailto:${COMPANY.email}`}
                className="text-white/90 hover:text-sky-300 whitespace-nowrap"
              >
                {COMPANY.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-sky-300 mt-0.5 shrink-0" />
              <span className="text-white/90 whitespace-nowrap">{COMPANY.area}</span>
            </li>
          </ul>
          <div className="mt-5 pt-5 border-t border-white/10 text-xs text-white/60">
            <div>ABN: {COMPANY.abn}</div>
            <div>{COMPANY.license}</div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-white/60">
          <div>© {new Date().getFullYear()} Cheerings Plumbing Group. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-sky-300">Privacy</a>
            <a href="#" className="hover:text-sky-300">Terms</a>
            <a href="#" className="hover:text-sky-300">Guarantee</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
